var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Detalhes do pedido")]),_c('b-overlay',{attrs:{"show":_vm.loading,"variant":"white","blur":"2rem","rounded":"sm"}},[_c('Form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }